import { Component, Injector, OnInit } from '@angular/core';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { deepCopy } from 'src/app/core/utils/common-functions';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { RolePermissionService } from '../../services/role-permission.service';

@Component({
  selector: 'laas-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent extends SessionBaseComponent implements OnInit {

  readonly helpPermissionCode: PermissionConstants = PermissionConstants.ViewManageRole;
  currentLang: string = this.laasSetting.language;

  allRoles: any[];
  searchParam: any;
  userTypeOptions: any[];
  isLoading: boolean;
  displayRoleDialog: boolean;
  modifyType: number;
  modifyRole: any;


  constructor(
    injector: Injector,
    private rolePermissionService: RolePermissionService
  ) {
    super(injector);
    this.allRoles = [];
    this.userTypeOptions = [];
    this.isLoading = false;
    this.displayRoleDialog = false;
    this.modifyType = 0;
    this.searchParam = {
      userType: '',
      roleCode: '',
      roleName: ''
    }
    this.modifyRole = {
      seqNo: null,
      roleCode: "",
      roleName: "",
      userType: "",
      isActivated: 1,
      istempActivated: true,
      currentUser: null
    }
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    console.log("this.userProfile", this.userProfile);
    this.loader.show();

    //userType Options
    const keys = Object.keys(UserType);
    this.userTypeOptions = keys.map(o => {
      return {
        label: o,
        value: o
      }
    });

    this.searchBtnClick(null);

    this.loader.hide();
  }

  searchBtnClick(event: any): void{
    this.isLoading = true;
    this.rolePermissionService.getRoles(this.searchParam).subscribe({
      next: result => {
        this.allRoles = result;
      },
      complete: () => {
        this.isLoading = false;
      }
    })
  }

  resetBtnClick(event: any): void{
    this.searchParam.userType = "";
    this.searchParam.roleCode = "";
    this.searchParam.roleName = "";
  }

  openModify(event: any, type: number, data: any): void{
    switch(type){
      case 1:
        this.modifyRole = {
          seqNo: null,
          roleCode: "",
          roleName: "",
          userType: "",
          isActivated: 1,
          istempActivated: true,
          currentUser: null
        }
        break;
      case 2:
        this.modifyRole = deepCopy(data);
        this.modifyRole.istempActivated = this.modifyRole.isActivated == 1;
        break;
    }

    this.modifyRole.currentUser = this.userProfile.userName;
    this.modifyType = type;
    this.displayRoleDialog = true;
  }

  saveRole(event: any): void{
    this.modifyRole.isActivated = this.modifyRole.istempActivated ? 1 : 0;
    this.modifyRole.currentUser = this.userProfile.userName;
    this.rolePermissionService.saveRole(this.modifyRole).subscribe({
      next: result => {
        if(this.modifyType == 1){
          //新增成功
          this.translateService.get('RoleMaintainance.Success.AddSuccess')
            .subscribe({
              next: result => {
                this.toastService.success(result);
              }
            });
        }else if(this.modifyType == 2){
          //UpdateSuccess
          this.translateService.get('RoleMaintainance.Success.UpdateSuccess')
            .subscribe({
              next: result => {
                this.toastService.success(result);
              }
            });
        }
      },
      complete: () => {
        this.displayRoleDialog = false;
        this.searchBtnClick(null);
      }
    })
  }

  goRolePermission(event: any, data: any): void{
    this.routeStateService.navigateTo('/User/rolePermission', {userType: data.userType, roleSeqNo: data.seqNo});
  }
}
